export default (context: any) => ({
  redirect: `/${context.params.notShit}`,
});
